import { useRef, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import API from '../../../Network/API';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';
import { ADD_COURSE_SECTION_SUCCESS, EDIT_COURSE_SECTION_SUCCESS } from '../../../Reducer/courseSectionSlice';

export default function EditSection({show,onHide,course_id,data}){
    const { t } = useTranslation();
    const [name, setName] = useState("");
    const [isLoading, setLoading] = useState(false);
    const dispatch = useDispatch();
    const inpRef = useRef()
    const modalRef1 = useRef()

    const handleSubmit = (event) => {
        event.preventDefault();
        setLoading(true);
        const fd = new FormData();
        fd.append('title', event.target.title.value)
        fd.append('course_id', course_id)
        fd.append('_method', 'PUT')
        API.post("/v1/oauth/teacher/sections/" + data?.id +"/update", fd, {
        }).then((response) => {
            setLoading(false)
            dispatch(EDIT_COURSE_SECTION_SUCCESS(response.data.data))
            document.getElementById("add_country_form").reset()
            modalRef1.current.click();
        }).catch((err) => {
            setLoading(false)
            toast.error(err?.response?.data?.message || t("editSection.update_failed"));
        });
      
    }

    return (
        <>
         <Modal show={show} onHide={onHide} keyboard="false"
 backdrop="static">
                <Modal.Header>
                    <h4 class="modal-title">{t("editSection.edit_section")}</h4>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" ref={modalRef1} onClick={onHide}></button>

                </Modal.Header>

                <Modal.Body>
                    <form onSubmit={handleSubmit} id="add_country_form">
                        <div className="row">
                            <div className="col-sm-12 mb-3">
                                <label htmlFor="name" className="form-label c-label">{t("editSection.name")}</label>
                                <input defaultValue={data?.name} required ref={inpRef} name='title' type="text" className="form-control rounded-pill" id="name" placeholder required />
                            </div>
                        </div>

                        <div class="modal-footer">
                            <button type="submit" class="btn btn-success">{t("editSection.save")} {isLoading ? (
                                <span
                                    className="spinner-border spinner-border-sm ml-5"
                                    role="status"
                                    aria-hidden="true"
                                ></span>
                            ) : (
                                <span></span>
                            )}</button>
                        </div>
                    </form>
                </Modal.Body>
            </Modal>
        </>
    )
}